import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import YupPassword from "yup-password";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {clearMessage} from "../slices/message";
import {messages} from "../i18n/messages";
import {LOCALES} from "../i18n/locales";
import {forgetPassword} from "../slices/auth";

const ForgetPassword = () => {
  const [successful, setSuccessful] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  const initialValues = {
    email: "",
  };

  YupPassword(Yup);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(messages[LOCALES.ENGLISH].invalid_email)
      .required(messages[LOCALES.ENGLISH].field_required)
  });

  const handleResetPassword = (formValue) => {
    const { email } = formValue;

    setSuccessful(false);
    setIsLoading(true);

    dispatch(forgetPassword({ email }))
      .unwrap()
      .then(() => {
        setSuccessful(true);
        setIsLoading(false);
      })
      .catch(() => {
        setSuccessful(false);
        setIsLoading(false);
      });
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={5}>
          <Card className="border-0 shadow-lg" style={{ borderRadius: '24px' }}>
            <div 
              style={{ 
                height: '120px', 
                background: 'var(--primary-gradient)', 
                borderTopLeftRadius: '24px', 
                borderTopRightRadius: '24px' 
              }}
            ></div>
            
            <Card.Body className="px-4 pb-5 pt-0">
              <div 
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center bg-white shadow-sm"
                style={{
                  width: '80px',
                  height: '80px',
                  marginTop: '-40px',
                  marginBottom: '20px',
                  border: '4px solid white',
                  fontSize: '2rem',
                  color: '#4f46e5'
                }}
              >
                <i className="bi bi-envelope-check-fill"></i>
              </div>

              <h3 className="fw-bold text-center mb-1" style={{ color: 'var(--text-main)' }}>
                Forgot Password
              </h3>
              <p className="text-center text-muted small mb-4">
                Enter your email address and we'll send you a link to reset your password.
              </p>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleResetPassword}
              >
                <Form>
                  {!successful && (
                    <div className="d-flex flex-column gap-3">
                      <div>
                        <label htmlFor="email" className="text-muted small fw-bold mb-1">Email Address</label>
                        <Field 
                          name="email" 
                          type="email" 
                          className="form-control form-control-lg bg-light border-0" 
                          style={{ fontSize: '1rem' }}
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-danger small mt-1 fw-medium"
                        />
                      </div>

                      <Button 
                        type="submit" 
                        className="btn-premium w-100 rounded-pill py-2 mt-2" 
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        ) : (
                          <i className="bi bi-send-fill me-2"></i>
                        )}
                        Send Reset Link
                      </Button>
                      
                      <div className="text-center mt-3">
                        <Link to="/login" className="text-decoration-none small fw-bold text-muted">
                          <i className="bi bi-arrow-left me-1"></i> Back to Login
                        </Link>
                      </div>
                    </div>
                  )}
                </Form>
              </Formik>

              {message && (
                <div className="mt-4">
                  <div
                    className={`alert ${successful ? "alert-success" : "alert-danger"} rounded-4 border-0 shadow-sm`}
                    role="alert"
                  >
                    <i className={`bi ${successful ? "bi-check-circle-fill" : "bi-exclamation-triangle-fill"} me-2`}></i>
                    {message}
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgetPassword;
